import React from 'react';
import PropTypes from 'prop-types';
import './Timer.css';
import { formatDuration, pad2 } from '../../utils/formatTime';

function Timer({ time }) {
  const {
    hours, minutes, seconds, tenths,
  } = formatDuration(time);

  // Number of glyphs actually rendered, so the CSS can scale the font down to
  // fit the viewport width once the (optional, variable-width) hours segment
  // appears. "MM:SS.t" is 7; "HH:MM:SS.t" is 10, more for 100+ hours.
  const charCount = (hours > 0 ? `${pad2(hours)}:` : '').length + '00:00.0'.length;

  return (
    <div
      className="timer"
      role="timer"
      aria-label="Elapsed time"
      style={{ '--timer-chars': charCount }}
    >
      {hours > 0 && (
        <span className="digits">
          {pad2(hours)}
          :
        </span>
      )}
      <span className="digits">
        {pad2(minutes)}
        :
      </span>
      <span className="digits">
        {pad2(seconds)}
        .
      </span>
      <span className="digits tenths">
        {tenths}
      </span>
    </div>
  );
}

Timer.propTypes = {
  time: PropTypes.number.isRequired,
};

export default Timer;
